import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DateRangeModel } from 'src/app/models/date-range-selection-models/date-range-model';
import dayjs from "dayjs";
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';

@Component({
    selector: 'app-date-range-selector',
    templateUrl: './date-range-selector.component.html',
    styleUrls: ['./date-range-selector.component.css'],
    standalone: false
})
export class DateRangeSelectorComponent {

  @Output() periodSelected = new EventEmitter<DateRangeModel>();
  dateSelectionForm: FormGroup;
  
  dateRangeList: DateRangeModel[] = [
    {description: "1 Month", period:  dayjs().subtract(30, 'day').toDate().toISOString()},
    {description: "3 Months", period:  dayjs().subtract(90, 'day').toDate().toISOString()},
    {description: "6 Months", period:  dayjs().subtract(180, 'day').toDate().toISOString()},
    {description: "12 Months", period:  dayjs().subtract(365, 'day').toDate().toISOString()},
    {description: "All", period:  dayjs().subtract(15, 'year').toDate().toISOString()},
    {description: "Custom", period:   dayjs().subtract(14, 'day').toDate().toISOString()},
  ];

  selectedDateRange?: DateRangeModel;
  defaultPeriod: any;

  constructor(private fb: FormBuilder,){
        this.dateSelectionForm = this.fb.group({
          periodSelect: new FormControl({})
        });
  }

  ngAfterContentInit(){
    this.dateSelectionForm.controls.periodSelect.setValue(this.dateRangeList[1]); // set default 3 months
  }

  onSelect(period: DateRangeModel): void {
    this.selectedDateRange = period;
    this.periodSelected.emit(period);
  }

}
